import { FunctionComponent, useState } from "react"
import { Button, Table } from "react-bootstrap"
import { Door, PassDoor } from "../data/models.interface"
import { sortArray } from "../utils/ArrayUtils"
import PassDoorModal from "./PassDoorModal"
import { formatDate } from "../utils/AccessControlFormatter"

interface IPassDoorsSubForm {
	passDoors: PassDoor[]
	setPassDoors: (value: PassDoor[]) => any
	doors: Door[]
}
const PassDoorsSubForm: FunctionComponent<IPassDoorsSubForm> = ({
	passDoors: value,
	setPassDoors: setValue,
	doors,
}) => {
	// this is which row is open in the modal; undefined means the modal is closed
	const [modalIndex, setModalIndex] = useState<number | null>(null)
	// sorting will call setValue with the items in a new order
	const sortBy = (sortProperty: string) => setValue(sortArray(value, sortProperty, "AUTO"))
	//
	return (
		<>
			<PassDoorModal
				onHide={() => setModalIndex(null)}
				passDoors={value}
				setPassDoors={setValue}
				index={modalIndex}
				doors={doors}
			/>
			<Table striped bordered hover size="sm">
				<thead>
					<tr>
						<th onClick={() => sortBy("doorFullName")}>Door</th>
						<th onClick={() => sortBy("startDate")}>Start Date</th>
						<th onClick={() => sortBy("endDate")}>End Date</th>
						<th onClick={() => sortBy("dailyStartTime")}>Start Time</th>
						<th onClick={() => sortBy("dailyEndTime")}>End Time</th>
					</tr>
				</thead>
				<tbody>
					{value?.map((passDoor, i) => (
						<tr key={passDoor.doorId} onClick={() => setModalIndex(i)}>
							<td>{passDoor.doorFullName || passDoor.doorId}</td>
							<td>{formatDate(passDoor.startDate)}</td>
							<td>{formatDate(passDoor.endDate)}</td>
							<td>{passDoor.dailyStartTime}</td>
							<td>{passDoor.dailyEndTime}</td>
						</tr>
					))}
					<tr>
						<td colSpan={10} className="text-center">
							<Button variant="outline-success" size="sm" onClick={() => setModalIndex(value?.length || 0)}>
								Add Door
							</Button>
						</td>
					</tr>
				</tbody>
			</Table>
		</>
	)
}
export default PassDoorsSubForm
